import { AMERICAS_COUNTRIES, EU_CHANNEL_DEFAULT_COUNTRIES } from "@/middleware";

export type MismatchDecision =
	| { kind: "none" }
	| { kind: "suggest-americas"; detectedCountry: string }
	| { kind: "suggest-worldwide"; detectedCountry: string };

export function classifyMismatch(params: {
	currentChannel: string;
	detectedCountry: string | null;
}): MismatchDecision {
	const { currentChannel, detectedCountry } = params;

	if (!detectedCountry) return { kind: "none" };

	const country = detectedCountry.toUpperCase();

	// Pinned EU-default countries: never suggest a channel change.
	if (EU_CHANNEL_DEFAULT_COUNTRIES.has(country)) {
		return { kind: "none" };
	}

	const channel = currentChannel.toLowerCase();

	// On /us but outside the Americas → suggest worldwide.
	if (channel === "us" && !AMERICAS_COUNTRIES.has(country)) {
		return { kind: "suggest-worldwide", detectedCountry: country };
	}

	// On /eu but in the Americas → suggest americas.
	if (channel === "eu" && AMERICAS_COUNTRIES.has(country)) {
		return { kind: "suggest-americas", detectedCountry: country };
	}

	return { kind: "none" };
}
